import React from "react";
import { SERVER_URL } from "../config/config.js";
import "./biltyReport.css";
import "react-datepicker/dist/react-datepicker.css";
import ReportTable from "./ReportTable";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReportExcel from "./ReportExcel.js";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
let ex_data = [];

function PartyReport({ sessionObject }) {
  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        canFilter: true,
        width: "150px",
        minWidth: "150px",
      },
      {
        Header: "GST",
        accessor: "gst",
        canFilter: true,
        width: "150px",
        minWidth: "150px",
      },
      {
        Header: "Bill Name",
        accessor: "bill_name",
        canFilter: true,
        width: "150px",
        minWidth: "150px",
      },
      {
        Header: "Bill GST",
        accessor: "bill_gst",
        canFilter: true,
        width: "160px",
        minWidth: "160px",
      },
      {
        Header: "Address",
        accessor: "address",
        canFilter: true,
        width: "220px",
        minWidth: "220px",
      },
      {
        Header: "Contact",
        accessor: "contact_person",
        canFilter: true,
        width: "150px",
        minWidth: "150px",
      },
    ],
    []
  );

  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(0);
  const [finalInput, setFinalInput] = React.useState({});
  const fetchIdRef = React.useRef(0);
  const download_ref = React.useRef(null);
  const [dateState, setDateState] = React.useState({
    date_from: new Date(),
    date_to: new Date(),
    in_stock: "Y",
  });
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  let query = useQuery();

  useEffect(() => {
    const reportType = query.get("report_type");
    console.log("data is : ", { data });
    setDateState({
      ...dateState,
      ["report_type"]: reportType,
    });
  }, []);

  const fetchData = React.useCallback(
    async ({ pageSize, pageIndex, sortBy, customFilters, dateObject }) => {
      const fetchId = ++fetchIdRef.current;
      
      const filteredFilters = Object.keys(customFilters).reduce((acc, key) => {
        if (key !== 'companyId' && key !== 'fyear') {
          acc[key] = customFilters[key];
        }
        return acc;
      }, {});
  
      console.log("Filtered customFilters: ", filteredFilters);
  
      setLoading(true);
  
      if (fetchId === fetchIdRef.current) {
        let inputData = {
          paginate: { number_of_rows: pageSize, page_number: pageIndex + 1 },
          filter_fields: filteredFilters,
          date_dict: {
            date_from: dateObject.date_from,
            date_to: dateObject.date_to,
          },
        };
        setFinalInput(inputData);
  
        try {
          let response = await fetch(SERVER_URL + "/report/company_master_report", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(inputData),
          });
  
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
  
          let resp = await response.json();
  
          if (resp["data"] && "total_rows" in resp) {
            resp["data"].forEach((row) => {
              row.is_active = row.is_active ? 1 : 0;
              row.is_admin = row.is_admin ? 1 : 0;
            });
  
            setData(resp["data"]);
            setPageCount(Math.ceil(resp?.total_rows["total_rows"] / pageSize));
          }
        } catch (error) {
          console.error("Error fetching data: ", error);
          setData([]);
        } finally {
          setLoading(false);
        }
      }
    },
    []
  );

  return (
    <div className="page-marfatiya-wise">
      <div className="report-bilty">
        <div className="form-header">Party Report</div>
        <div className="report-bilty-table-container">
          <ReportTable
            columns={columns}
            data={data}
            fetchData={fetchData}
            dateObject={dateState}
            loading={loading}
            pageCount={pageCount}
          />
          <div className="form-footer">
            <button style={{ display: "none" }}>
              <ReactHTMLTableToExcel
                id="test-table-xls-button"
                className="download-table-xls-button"
                table="bilty_report_excel"
                filename="tablexls"
                sheet="tablexls"
                buttonText="Download as XLS"
                ref={(a) => (download_ref.current = a)}
              />
            </button>
            <button
              className="download-table-xls-button"
              onClick={async () => {
                setLoading(true);
                let dataToSend = {
                  filter_fields: finalInput.filter_fields,
                  paginate: {
                    number_of_rows: 300,
                    page_number: 1,
                  },
                };
                let resp = await fetch(
                  SERVER_URL + "/report/party_rate_report",
                  {
                    method: "POST",
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(dataToSend),
                  }
                );
                let response = await resp.json();

                if (response["data"] && "total_rows" in response) {
                  console.log(response["data"], "fsdfafsfds");
                  ex_data = response["data"];
                }
                setLoading(false);
                download_ref.current.handleDownload();
              }}
            >
              Download as XLS
            </button>
            {/* {ReportExcel.excel_party_rate(
                            { columns },
                            { ex_data },
                            { fetchData },
                            { dateState },
                            { loading },
                            { pageCount },
                            { dateState }
                        )} */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PartyReport;
